export const VIDEO_VOLUME = 'videoVolume';
export const USER_INTERACTED = 'userInteracted';
